import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { UpdateIconColorModel } from '@smarttask-common/src/lib/models/General/UpdateIconColorModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class ReportHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.report_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.report_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.report_create, (report_id: string) => {
            this.broadcast(SharedEventNameEnum.report_create, { report_id });
        });

        this.on(SharedEventNameEnum.report_name_update, (report_id: string, name: string) => {
            this.broadcast(SharedEventNameEnum.report_name_update, { report_id, name });
        });

        this.on(SharedEventNameEnum.report_icon_color_update, (report_id: string, model: UpdateIconColorModel) => {
            this.broadcast(SharedEventNameEnum.report_icon_color_update, { report_id, model });
        });

        this.on(SharedEventNameEnum.report_order_update, (report_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.report_order_update, { report_id, order_index });
        });

        this.on(SharedEventNameEnum.report_delete, (report_id: string) => {
            this.broadcast(SharedEventNameEnum.report_delete, { report_id });
        });

        this.on(SharedEventNameEnum.report_card_add, (report_id: string, card_id: string) => {
            this.broadcast(SharedEventNameEnum.report_card_add, { report_id, card_id });
        });

        this.on(SharedEventNameEnum.report_card_update, (report_id: string, card_id: string) => {
            this.broadcast(SharedEventNameEnum.report_card_update, { report_id, card_id });
        });

        this.on(SharedEventNameEnum.report_card_remove, (report_id: string, card_id: string) => {
            this.broadcast(SharedEventNameEnum.report_card_remove, { report_id, card_id });
        });
    };
}
